export default __webpack_public_path__ + "static/media/immigration.e9c3a74f.svg";